import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=3098b8be&scoped=true"
import script from "./ArticleInfo.vue?vue&type=script&lang=js"
export * from "./ArticleInfo.vue?vue&type=script&lang=js"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=3098b8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f87e3863bbacd24b3d835a89ae544fd6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3098b8be",
  null
  
)

export default component.exports